(function () {
  'use strict';
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  var cfg = window.JWANOU_CART || {};
  var drawer, body, count, subtotal, shipWrap, shipMsg, shipBar, foot, lastFocus;

  function money(c) {
    var f = cfg.moneyFormat || '${{amount}}';
    var a = (c / 100).toFixed(2).split('.');
    a[0] = a[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount[^}]*\}\}/, a.join('.'));
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  function setOpen(open) {
    if (!drawer) return;
    drawer.dataset.open = open ? 'true' : 'false';
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    var scrim = $('[data-jw-cart-scrim]');
    if (scrim) scrim.dataset.open = open ? 'true' : 'false';
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      lastFocus = document.activeElement;
      var f = drawer.querySelector('button,a');
      if (f) f.focus();
    } else if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }

  function lineHtml(item, i) {
    var src = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '';
    var img = src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '';
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<span class="jw-cart__var">' + esc(item.variant_title) + '</span>' : '';
    return '<div class="jw-cart__line" data-key="' + esc(item.key) + '">' +
      '<a class="jw-cart__thumb" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
      '<div class="jw-cart__info">' +
        '<div class="jw-cart__row">' +
          '<a class="jw-cart__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          '<span class="jw-cart__price">' + money(item.final_line_price) + '</span>' +
        '</div>' + variant +
        '<div class="jw-cart__ctrls">' +
          '<div class="jw-cart__qty">' +
            '<button type="button" data-jw-line="' + (i + 1) + '" data-to="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-jw-line="' + (i + 1) + '" data-to="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="jw-cart__rm" data-jw-line="' + (i + 1) + '" data-to="0">Remove</button>' +
        '</div>' +
      '</div></div>';
  }

  function render(cart) {
    if (!drawer || !cart) return;
    if (count) count.textContent = cart.item_count;

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="jw-cart__empty"><p class="jw-eyebrow">Your bag is empty</p>' +
        '<a href="' + esc(cfg.shopUrl || '/collections/all') + '" class="jw-btn">Start shopping</a></div>';
      if (foot) foot.hidden = true;
      if (shipWrap) shipWrap.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map(lineHtml).join('');
    if (foot) foot.hidden = false;
    if (subtotal) subtotal.textContent = money(cart.total_price);

    if (shipWrap && cfg.freeShipThreshold > 0) {
      shipWrap.hidden = false;
      var left = cfg.freeShipThreshold - cart.total_price;
      if (left > 0) {
        shipMsg.innerHTML = 'You are ' + money(left) + ' away from <strong>free shipping</strong>.';
        shipBar.style.width = Math.min(100, (cart.total_price / cfg.freeShipThreshold) * 100) + '%';
      } else {
        shipMsg.innerHTML = '<strong>Free shipping unlocked.</strong>';
        shipBar.style.width = '100%';
      }
    } else if (shipWrap) { shipWrap.hidden = true; }
  }

  function syncCounts(cart) {
    $$('[data-jw-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  function fetchCart(open) {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); if (open) setOpen(true); return cart; })
      .catch(function () {});
  }

  function changeLine(line, qty) {
    body.classList.add('jw-cart__busy');
    fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); syncCounts(cart); })
      .catch(function () {})
      .then(function () { body.classList.remove('jw-cart__busy'); });
  }

  function boot() {
    drawer = $('[data-jw-cart]');
    if (!drawer || drawer.dataset.bound === '1') return;
    drawer.dataset.bound = '1';

    body = $('[data-jw-cart-body]', drawer);
    count = $('[data-jw-cart-title-count]', drawer);
    subtotal = $('[data-jw-cart-subtotal]', drawer);
    foot = $('[data-jw-cart-foot]', drawer);
    shipWrap = $('[data-jw-cart-ship]', drawer);
    shipMsg = $('[data-jw-cart-ship-msg]', drawer);
    shipBar = $('[data-jw-cart-ship-bar]', drawer);

    $$('[data-jw-cart-close]').forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
    var scrim = $('[data-jw-cart-scrim]');
    if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.dataset.open === 'true') setOpen(false);
    });
    $$('[data-jw-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); fetchCart(true); });
    });
    body.addEventListener('click', function (e) {
      var b = e.target.closest('[data-jw-line]');
      if (!b) return;
      changeLine(parseInt(b.dataset.jwLine, 10), parseInt(b.dataset.to, 10));
    });
    document.addEventListener('jwanou:cart:updated', function (e) { render(e.detail); setOpen(true); });

    fetchCart(false);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
